import React from "react";
import { useSelector } from "react-redux";
import {
  filterSupplyGroupsByMonthYear,
  groupInventoriesBySupply,
} from "./utils";

export default function Footer() {
  const {
    collections = [],
    lastFetchedAtByClinic = {},
    currentInventoryCacheKey = "",
    selectedMonth,
    selectedYear,
  } = useSelector(({ clinicInventory }) => clinicInventory);

  const groups = React.useMemo(
    () =>
      filterSupplyGroupsByMonthYear(
        groupInventoriesBySupply(collections),
        selectedMonth,
        selectedYear,
      ),
    [collections, selectedMonth, selectedYear],
  );
  const lastFetchedAt = lastFetchedAtByClinic[currentInventoryCacheKey] || "";

  const totalAvailable = groups.reduce(
    (sum, group) => sum + Number(group?.availableUnits || 0),
    0,
  );

  return (
    <div className="mb-auto d-flex justify-content-between align-items-center px-4 py-2 text-muted small flex-wrap">
      <span>Total available units: {totalAvailable}</span>
      <span>
        Last synced:{" "}
        {lastFetchedAt
          ? new Date(lastFetchedAt).toLocaleString("en-PH", {
              month: "short",
              day: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "2-digit",
            })
          : "Not yet synced"}
      </span>
    </div>
  );
}
